import dayjs from 'dayjs';
import type { DashboardHappinessSurveyItem } from '@/api/dashboardApi';

export function isToDo(status: string): boolean {
  return status === 'To Do';
}

export function isResolved(status: string): boolean {
  return status === 'Completed' || status === 'Expired';
}

function byDueDateDescending(a: DashboardHappinessSurveyItem, b: DashboardHappinessSurveyItem): number {
  return dayjs(b.dueDate).valueOf() - dayjs(a.dueDate).valueOf();
}

export function selectVisibleSurveys(
  surveys: DashboardHappinessSurveyItem[],
  showResolved: boolean
): DashboardHappinessSurveyItem[] {
  const toDo = surveys.filter((s) => isToDo(s.status));

  if (!showResolved) {
    return toDo;
  }

  const resolved = surveys.filter((s) => isResolved(s.status)).sort(byDueDateDescending);
  return [...toDo, ...resolved];
}
